import { memo } from 'react'
import { useStreamWatchdog } from '../../hooks/useStreamWatchdog.js'
import './LiveViewer.css'

const WEBRTC_PREVIEW_URL = '/stream/webrtc/antenna/?controls=true&muted=true&autoplay=true&playsInline=true&disablepictureinpicture=false'
const HLS_PREVIEW_URL = '/stream/hls/antenna/?controls=true&muted=true&autoplay=true&playsInline=true&disablepictureinpicture=false'

type PreviewTransport = 'WebRTC' | 'HLS'

function getPreviewTransport(): PreviewTransport {
  const requested = new URLSearchParams(window.location.search).get('transport')?.toLowerCase()
  if (requested === 'hls') return 'HLS'
  if (requested === 'webrtc') return 'WebRTC'
  return window.location.protocol === 'https:' ? 'HLS' : 'WebRTC'
}

export const LiveViewer = memo(function LiveViewer() {
  // Même chien de garde que le retour antenne embarqué : le lecteur plein
  // écran se relance seul plutôt que d'attendre un rechargement de page.
  const { playerKey, iframeRef, live, unavailable, onFrameLoad, reload } = useStreamWatchdog()
  const transport = getPreviewTransport()
  const previewUrl = transport === 'HLS' ? HLS_PREVIEW_URL : WEBRTC_PREVIEW_URL

  return (
    <main className="live-viewer">
      <header className="live-viewer__header">
        <div>
          <div className="live-viewer__brand">TrafficPlay</div>
          <div className="live-viewer__subtitle">Retour antenne</div>
        </div>
        <div className="live-viewer__actions">
          <span className={`live-viewer__state ${live ? 'is-live' : 'is-connecting'}`} aria-live="polite">
            <span className="live-viewer__dot" aria-hidden="true" />
            {live ? 'EN DIRECT' : unavailable ? 'INDISPONIBLE' : 'CONNEXION'}
          </span>
          <button type="button" onClick={reload} className="live-viewer__button" title="Recharger le lecteur">
            Recharger
          </button>
          <a href="/" className="live-viewer__link">TrafficPlay</a>
        </div>
      </header>

      <section className="live-viewer__stage" aria-label="Retour vidéo en direct">
        <div className="live-viewer__frame">
          <iframe
            key={playerKey}
            ref={iframeRef}
            src={previewUrl}
            title="Retour vidéo TrafficPlay"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            onLoad={onFrameLoad}
            className={`live-viewer__iframe${unavailable ? ' is-hidden' : ''}`}
          />
          {unavailable && <div className="live-viewer__unavailable">Retour non disponible</div>}
        </div>
      </section>

      <footer className="live-viewer__footer">
        <span>{transport}</span>
        {transport === 'HLS' && <span>Via tunnel HTTPS</span>}
        <span>960 x 540</span>
        <span>Lecture seule</span>
      </footer>
    </main>
  )
})
